import { authHeader } from '../_helpers';
import { handleResponse } from '../_helpers';
import { apiClient } from '../_helpers';

export const productService = {
  getAll,
  getById,
  addProduct,
  updateProduct
};

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/ingredients`, requestOptions).then(handleResponse);
}
function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
};

  return fetch(`${process.env.VUE_APP_API_HOSTNAME}/api/ingredients/${id}`, requestOptions).then(handleResponse);
}
function addProduct(newProduct) {
  return apiClient('ingredients/')
  .post('',`${JSON.stringify(newProduct)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}
function updateProduct(product) {
  return apiClient(`ingredients/${product.id}`)
  .put('',`${JSON.stringify(product)}`)
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return error;
  });
}